import React from 'react'

export default function MenuItem(props) {
    return (
        <div className = "MenuItem-container">
            <div className="MenuItem">
                <img src = {props.img} alt = {props.section}/>
                <div className = "MenuItem-Bottom">
                    <h1>{props.section}</h1>
                </div>
            </div>
        </div>
    )
}
